/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thankyou_FooterInputs */

const en_thankyou_footer = /** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Platform infrastructure`)
};

const es_thankyou_footer = /** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestructura de Plataforma Sovereign`)
};

const fr_thankyou_footer = /** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure de plateforme Sovereign`)
};

const de_thankyou_footer = /** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-Plattform-Infrastruktur`)
};

const id_thankyou_footer = /** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktur Platform Sovereign`)
};

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const ja_thankyou_footer = en_thankyou_footer;

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const zh_thankyou_footer = en_thankyou_footer;

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const ar_thankyou_footer = en_thankyou_footer;

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const it_thankyou_footer = en_thankyou_footer;

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const ru_thankyou_footer = en_thankyou_footer;

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const pt_thankyou_footer = en_thankyou_footer;

/** @type {(inputs: Thankyou_FooterInputs) => LocalizedString} */
const ko_thankyou_footer = en_thankyou_footer;

/**
* | output |
* | --- |
* | "Sovereign Platform infrastructure" |
*
* @param {Thankyou_FooterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thankyou_footer = /** @type {((inputs?: Thankyou_FooterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thankyou_FooterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thankyou_footer(inputs)
	if (locale === "es") return es_thankyou_footer(inputs)
	if (locale === "fr") return fr_thankyou_footer(inputs)
	if (locale === "de") return de_thankyou_footer(inputs)
	if (locale === "ja") return ja_thankyou_footer(inputs)
	if (locale === "zh") return zh_thankyou_footer(inputs)
	if (locale === "ar") return ar_thankyou_footer(inputs)
	if (locale === "id") return id_thankyou_footer(inputs)
	if (locale === "it") return it_thankyou_footer(inputs)
	if (locale === "ru") return ru_thankyou_footer(inputs)
	if (locale === "pt") return pt_thankyou_footer(inputs)
	return ko_thankyou_footer(inputs)
});